export default {"src":"/_next/static/media/deco_checkout_checkmark_box.8f181146.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};